import React from 'react';
import TopPanel from "../toppanel.js";

module.exports = React.createClass({
    componentDidMount: function () {
        this.drawQrCode();
        HC_SubscribeHammerEvent(this.refs.panel, "swiperight", this.props.onGoBack);
    },
    componentWillUnmount: function () {
        HC_UnsubscribeHammerEvent(this.refs.panel, "swiperight");
    },

    saveQRCode: function () {
        var report = HC_GetItemById(this.props.data, this.props.selectedId);
        window.location = '/qr/' + report.link;
    },
    printQRCode: function (e) {
        var report = HC_GetItemById(this.props.data, this.props.selectedId);
        var oldColor = $('body').css('background-color');
        $('body').css('background-color', 'white');
        $('.hc_outerframe').css('display', 'none');
        var div = document.createElement('div');
        div.innerHTML = `
                        <div id="qr-report-name" class="hc-f3" style="text-align:center; padding:2rem; padding-top:100px">` + report.name + `</div>
                        <div id="hc_report_qrcode2" style="margin:auto; width: 250px; height: 250px; padding-bottom: 100px"></div>
        `;
        document.body.appendChild(div);
        this.drawQrCode('#hc_report_qrcode2');
        window.print();
        $('body').css('background-color', oldColor);
        document.body.removeChild(div);
        $('.hc_outerframe').css('display', '');
    },

    drawQrCode: function(id='#hc_report_qrcode') {
        var report = HC_GetItemById(this.props.data, this.props.selectedId);
        var linkAddr = '/report/' + report.link;
        var fullLinkAddr;
        if (window.HC_SERVER) {
            fullLinkAddr = window.HC_SERVER + linkAddr;
        } else {
            fullLinkAddr = window.location.origin + linkAddr;
            //fullLinkAddr = fullLinkAddr.slice(fullLinkAddr.indexOf('//') + 2);
        }

        $(id).empty();
        $(id).qrcode({width: 250, height: 250, text: fullLinkAddr});
    },

    render: function() {
        var report = HC_GetItemById(this.props.data, this.props.selectedId);
        this.drawQrCode();

        var buttons;
        if (!window.cordova) {
            buttons = (<div id="qr-buttons-div" style={{display:'inline-block', margin:'2rem'}}>
                <button type='button' className='hc-button' style={{marginRight:'1rem'}} onClick={this.printQRCode}>{HC_LANG.REP_PRINT}</button>
                <button type='button' className='hc-button' onClick={this.saveQRCode}>{HC_LANG.REP_SAVE_QR_CODE}</button>
            </div>);
        }

        return (
            <div className="hc-internal-panel">
                <TopPanel text={HC_LANG.REP_QR_CODE} licon="fa-angle-left" onLiconClick={this.props.onGoBack}/>
                <div ref="panel" className="hc-flex-display" style={{position:"absolute", width:"100%", top:"60px", bottom:"0",overflowX:"hidden", overflowY:"auto", WebkitOverflowScrolling:'touch', display:'flex'}}>
                    <div id="hc-qr-div-element" className="hc-qr-div" style={{textAlign:'center', margin:'auto', marginTop: '50px'}}>
                        <div id="qr-report-name" className="hc-f3"
                             style={{textAlign:'center', margin:'1rem'}}>{report.name}</div>
                        <div style={{textAlign:'center'}}>
                            <div id="hc_report_qrcode" style={{margin:"auto"}}></div>
                        </div>
                        {buttons}
                    </div>
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/PanelQR.js